<template>
  <div class="form-group">
    <div class="form">
      <label class="label-tag">
        {{ $t('ct-tag') }}
        <input type="text" v-model="tag" class="form-control" :placeholder="$t('ct-tag-plch')" @change="changeValue" @keyup="changeValue"
               @toggle="changeValue">
      </label>
    </div>
	<alert-box-component type="warning" :with_icon="true" class="alert-tag">
		<p
			slot="content"
			v-text="$t('ct-alert-tag')"
		/>
	</alert-box-component>
  </div>
</template>

<script>

import AlertBoxComponent from '../../commons/AlertBoxComponent';

	export default {
		name: 'TagComponent',
		components: {
    		AlertBoxComponent
		},
		data() {
			return {
				tag: '',
        callback: () => {},
			}
		},
		methods: {
			changeValue() {
        this.callback(this.tag);
			},
			setValues(obj) {
				this.tag = obj.tag;
				this.callback = obj.callback;
			}
		},
	}

</script>

<style scoped lang="scss">

	.form-group {
		overflow: hidden;
	}

	.label-tag {
		width: 100%;
	}

</style>







// WEBPACK FOOTER //
// src/components/editor/resource_components/Tag.vue